import { render, staticRenderFns } from "./file-conf-detail.vue?vue&type=template&id=770e5e08&scoped=true&"
import script from "./file-conf-detail.vue?vue&type=script&lang=ts&"
export * from "./file-conf-detail.vue?vue&type=script&lang=ts&"
import style0 from "./file-conf-detail.vue?vue&type=style&index=0&id=770e5e08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e5e08",
  null
  
)

export default component.exports